import { useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { useCurrentUserMaybe } from "~/auth/CurrentUserContext"
import { signInPath } from "~/common/paths"
import { useDocumentTitle } from "~/common/useDocumentTitle"
import { useHomePath } from "~/common/useHomePath"

export const LoadingScreen = () => {
  useDocumentTitle("Loading")
  const navigate = useNavigate()
  const { currentUser, result } = useCurrentUserMaybe()
  const homePath = useHomePath()

  useEffect(() => {
    if (currentUser) {
      navigate(homePath)
    } else if (!result.loading) {
      navigate(signInPath.pattern)
    }
  }, [currentUser, result.loading, navigate, homePath])

  return null
}
